import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Table } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import label from '../../utils/lngEn';
import StudentSteps from '../common/StudentSteps';
import StudentForm from './forms/StudentForm';
import * as utils from '../../utils/utils';
import * as profileActions from '../../actions/profileActionCreators';
import * as runActions from '../../actions/runsActionCreators';

class ProfileStudent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  componentWillMount() {
    this.props.runActions.getRuns(0);
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
  }

  handlePasswordChange = values => {
    this.props.profileActions
      .changePassword(values)
      .then(() => {
        console.log('PASSWORD CHANGED');
      })
      .catch(() => {
        console.log('PASSWORD NOT CHANGED');
      });
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="page-title">Profile</div>
            <StudentSteps active={-1} elicitation={this.props.run.is_eliciting} />
            <Row>
              <Col md={8}>
                <div className="page-subtitle">Account Information</div>
                <div>
                  <label>Username</label>
                  <span className="username">{utils.getUser()}</span>
                  <StudentForm onSubmit={this.handlePasswordChange} />
                </div>

                <div className="page-subtitle">Frequently Asked Questions</div>
                <div className="profile-faq">
                  <div className="faq-q">{label.sq1}</div>
                  <p className="faq-a">{label.sa1}</p>
                  <div className="faq-q">{label.sq4}</div>
                  <p className="faq-a">{label.sa4}</p>
                  <div className="faq-q">{label.sq5}</div>
                  <p className="faq-a">{label.sa5}</p>
                  <div className="faq-q">{label.sq6}</div>
                  <p className="faq-a">{label.sa6}</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="sidebar-container">
                  <div className="sidebar-header">Assignments</div>
                  <div className="c-table sidebar-table">
                    <Table condensed hover>
                      <thead>
                        <tr>
                          <th />
                          <th>Name</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.runs.map((run, index) => {
                          if (run.is_eliciting) {
                            return (
                              <tr key={index} className={run.slug == localStorage.getItem('run') ? 'active' : ''}>
                                <td className="assign-icon">
                                  <a href={`/rank/${run.slug}`}>
                                    <i className="fa fa-check-circle-o" />
                                  </a>
                                </td>
                                <td className="assign-name">
                                  <a href={`/rank/${run.slug}`}>{run.slug}</a>
                                </td>
                                <td className="assign-desc">{run.longname}</td>
                              </tr>
                            );
                          }
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    runs: state.runs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileStudent);



// WEBPACK FOOTER //
// ./src/components/profile/ProfileStudent.js